// NOTE
// Please use your own firebase details below.
// For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html
import Vue from 'vue'
import { firestorePlugin } from 'vuefire' // add
import firebase from 'firebase/app'
import 'firebase/firestore' // add
import 'firebase/database'


Vue.use(firestorePlugin) // add

// Initialize Firebase
const config = {
  // amacode stock test
  /*
  apiKey: 'AIzaSyAxcFDjmkxwS9ZmavGxgfZR9n18BOzmJ2s',
  authDomain: 'amacode-stock-test.firebaseapp.com',
  databaseURL: 'https://amacode-stock-test.firebaseio.com',
  projectId: 'amacode-stock-test',
  storageBucket: 'amacode-stock-test.appspot.com',
  messagingSenderId: '968794756304',
  appId: '1:968794756304:web:3a504ff204c4b8bebb7ad5',
  measurementId: 'G-VSE1LPEMKP'
  */
  // amacode stock（production）
  apiKey: 'AIzaSyDjBGJn3Dpb7e4oyy9WddD_XPM6YTZX7z0',
  //authDomain: 'amacode-1afb2.firebaseapp.com',
  authDomain: 'console.amacode.app',
  databaseURL: 'https://amacode-1afb2.firebaseio.com',
  projectId: 'amacode-1afb2',
  storageBucket: 'amacode-1afb2.appspot.com',
  messagingSenderId: '461627982168',
  appId: '1:461627982168:web:086d3ce01801e0bec7e52d'
}

firebase.initializeApp(config)